/* Tease quiz result page.
 *
 * Everything visible is written by Liquid from the theme editor. This file only
 * does the four things Liquid cannot:
 *
 *   1. Pick which of the four kits to show, from the quiz answer on the end of
 *      the address (Liquid cannot read the address).
 *   2. Put her first name in the headline.
 *   3. Run the ritual builder: open and close the steps, add and remove items,
 *      work out the total, decide whether the free blend is earned.
 *   4. Put the ritual in a real Shopify basket and go to checkout, with the
 *      right subscription plan and the right discount code.
 *
 * Address it understands:
 *   /pages/<handle>?result=deep-sleep&name=Sarah
 *   ?preview=1   shows the four-kit switcher, for review only
 *
 * Nothing here writes to the page's wording. If a line is wrong, it is wrong in
 * the theme editor, not in this file.
 */
(function () {
  'use strict';

  /* Each quiz section links this file, so the page still works if any one
     section is removed in the theme editor. That means the tag can appear more
     than once, and a browser runs every tag even though it only downloads the
     file once. This makes the second and later runs do nothing, so nothing gets
     wired twice and a single tap can never add an item twice. */
  if (window.__teaseQuizResultsLoaded) return;
  window.__teaseQuizResultsLoaded = true;

  var ROOT_LIVE = 'ttq-live';
  var money = function (n) {
    return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
  };
  var num = function (el, attr, fallback) {
    var v = parseFloat(el.getAttribute(attr));
    return isNaN(v) ? (fallback || 0) : v;
  };
  var yes = function (el, attr) { return el.getAttribute(attr) === 'true'; };
  var qsa = function (sel, within) {
    return Array.prototype.slice.call((within || document).querySelectorAll(sel));
  };

  /* ------------------------------------------------------- which kit to show
   * The quiz has seven outcomes and the page has four kits, because two kits
   * each answer two outcomes. The mapping is read off the page, so it can be
   * changed in the theme editor without touching this file. The built-in map is
   * only a safety net for the case where somebody clears those fields.
   */
  var FALLBACK_ROUTES = {
    'coffee-swap': 'calm-energy', 'ritual': 'calm-energy',
    'switch-off': 'wind-down', 'deep-sleep': 'wind-down',
    'calm-gut': 'settle', 'defense': 'settle',
    'glow': 'glow'
  };

  function routes() {
    var map = {};
    Object.keys(FALLBACK_ROUTES).forEach(function (k) { map[k] = FALLBACK_ROUTES[k]; });
    qsa('[data-ttq-result]').forEach(function (el) {
      var kit = el.getAttribute('data-ttq-result');
      map[kit] = kit;                                  // a kit key always matches itself
      (el.getAttribute('data-ttq-slugs') || '').split(',').forEach(function (s) {
        s = s.trim().toLowerCase();
        if (s) map[s] = kit;
      });
    });
    return map;
  }

  function params() {
    try { return new URLSearchParams(window.location.search); }
    catch (e) { return { get: function () { return null; } }; }
  }

  function chooseKit() {
    var p = params();
    var asked = (p.get('result') || p.get('kit') || p.get('outcome') || '').trim().toLowerCase();
    var map = routes();
    if (asked && map[asked]) return map[asked];
    var first = document.querySelector('[data-ttq-result]');
    return first ? first.getAttribute('data-ttq-result') : null;
  }

  function showKit(kit) {
    qsa('[data-ttq-result]').forEach(function (el) {
      el.classList.toggle(ROOT_LIVE, el.getAttribute('data-ttq-result') === kit);
    });
    document.documentElement.setAttribute('data-ttq-showing', kit || '');
  }

  /* ------------------------------------------------------------- her name */
  function fillName(name) {
    qsa('[data-ttq-greeting]').forEach(function (el) {
      var withName = el.getAttribute('data-ttq-greeting-with') || 'NAME, your';
      var without = el.getAttribute('data-ttq-greeting') || 'Your';
      el.textContent = name ? withName.replace('NAME', name) : without;
    });
    qsa('[data-ttq-first-name]').forEach(function (el) { el.textContent = name || ''; });
  }

  /* ------------------------------------------------------------ the builder
   * One builder per kit. Only the visible one is ever driven, but they are all
   * wired, so the switcher can flip between them with no re-wiring.
   */
  function Builder(root) {
    var self = this;
    this.root = root;
    /* There is deliberately no one-time percentage read here any more. The
       one-time saving is whatever "Buy 3, Get Your 4th Free" gives on the real
       basket, and the auto-ship saving is carried per blend by its own selling
       plan. A percentage sitting in a theme setting is exactly how the page
       came to promise "save 15%" on a basket that saved 25%. */
    this.threshold = num(root, 'data-ttq-free-threshold', 3);
    this.cups = num(root, 'data-ttq-cups', 60);
    this.freeOn = yes(root, 'data-ttq-free-enabled');
    /* The store's "Buy 3, Get Your 4th Free" discount is automatic, and it does
       NOT fire on a subscription order. Proven in a real basket: four blends
       one-time comes to $66 with $22 taken off, the same four on auto-ship comes
       to $57.20 with nothing taken off. So unless somebody extends that discount
       to subscriptions, the free blend is a one-time thing, and the page must not
       promise it on auto-ship or the total she is shown will not be the total she
       is charged. */
    this.freeOnSub = yes(root, 'data-ttq-free-on-sub');
    this.emptyFirst = yes(root, 'data-ttq-empty-cart');
    this.sub = root.getAttribute('data-ttq-default-plan') === 'sub';
    this.openStep = 1;
    this.busy = false;

    this.free = {
      vid: root.getAttribute('data-ttq-free-vid') || '',
      plan: root.getAttribute('data-ttq-free-plan') || '',
      price: num(root, 'data-ttq-free-price'),
      title: root.getAttribute('data-ttq-free-title') || '',
      fn: root.getAttribute('data-ttq-free-fn') || ''
    };

    this.items = qsa('[data-ttq-item]', root).map(function (el) {
      return {
        el: el,
        key: el.getAttribute('data-ttq-item'),
        title: el.getAttribute('data-ttq-title') || '',
        fn: el.getAttribute('data-ttq-fn') || '',
        price: num(el, 'data-ttq-price'),
        was: num(el, 'data-ttq-was'),
        /* What THIS blend costs on auto-ship, off its own selling plan. Not a
           percentage of anything: the plans are not all the same, and their
           names lie about it (see snippets/ttq-selling-plan.liquid). */
        subPrice: num(el, 'data-ttq-item-sub'),
        vid: el.getAttribute('data-ttq-vid') || '',
        plan: el.getAttribute('data-ttq-plan') || '',
        role: el.getAttribute('data-ttq-role') || 'chosen',
        hardware: yes(el, 'data-ttq-hardware'),
        sold_out: yes(el, 'data-ttq-sold-out'),
        on: el.getAttribute('data-ttq-role') === 'chosen' && !yes(el, 'data-ttq-sold-out')
      };
    }).filter(function (i) { return i.role !== 'free'; });

    this.promoted = this.fillGapsFromSoldOut();

    this.wire();
    this.paintSteps();
    this.recalc();

    root.addEventListener('click', function (e) {
      var add = e.target.closest('[data-ttq-add]');
      if (add) {
        e.preventDefault();
        var item = self.byKey(add.getAttribute('data-ttq-add'));
        if (item && !item.sold_out) { item.on = !item.on; self.paintItem(item); self.recalc(); }
        return;
      }
      var next = e.target.closest('[data-ttq-next]');
      if (next) {
        e.preventDefault();
        e.stopPropagation();
        self.openStep = parseInt(next.getAttribute('data-ttq-next'), 10) + 1;
        self.paintSteps();
        self.recalc();
        var last = next.getAttribute('data-ttq-last') === 'true';
        /* The last step's button is "Confirm my ritual". On a phone the panel
           sits below the steps, so the scroll IS the feedback. On a laptop the
           panel is already beside the button and barely moves, so the checkout
           button changes colour instead, otherwise the click looks like it did
           nothing. Added 02/09/2026. */
        if (last) {
          var panel = self.root.querySelector('[data-ttq-panel]');
          if (panel) { panel.classList.add('ttq-confirmed'); }
        }
        self.scrollToOpen(last);
        return;
      }
      var head = e.target.closest('[data-ttq-open]');
      if (head) {
        var n = parseInt(head.getAttribute('data-ttq-open'), 10);
        self.openStep = (self.openStep === n) ? 0 : n;
        self.paintSteps();
        self.recalc();
        return;
      }
      var plan = e.target.closest('[data-ttq-plan-option]');
      if (plan) {
        self.sub = plan.getAttribute('data-ttq-plan-option') === 'sub';
        self.recalc();
        return;
      }
      var buy = e.target.closest('[data-ttq-buy]');
      if (buy) { e.preventDefault(); self.checkout(); }
    });
  }

  /* ------------------------------------------------ sold out, so promote one
   * Stock is per country. The same kit can have a blend that is fine in the USA
   * and gone in Canada: checked live on 15/08/2026, Organic Ceremonial Matcha
   * was sold out in Canada and in stock in the USA, while Berry Booster was the
   * other way round. Shopify already renders the right answer for whoever is
   * looking, so nothing here needs to ask what country she is in.
   *
   * What the page used to do was show the sold-out blend greyed out and leave
   * her ritual one short, so a four-blend kit quietly became three.
   *
   * What it does now: for every chosen blend that is sold out, tick the first
   * optional blend of that same kit that IS in stock. She still gets four, and
   * the stand-in is a blend already picked for this kit, so it still fits what
   * she answered. Nothing is invented and no new product list is needed.
   *
   * Hardware is never used as a stand-in, only blends. If there are not enough
   * in-stock optional blends to cover the gaps, it fills what it can rather
   * than nothing, and the ritual is simply short, which is the old behaviour.
   */
  Builder.prototype.fillGapsFromSoldOut = function () {
    var wanted = 0, have = 0, blanks = [];
    this.items.forEach(function (i) {
      if (i.role !== 'chosen') return;
      wanted++;
      if (i.on) have++;
      else if (i.sold_out) blanks.push(i);
    });
    var gaps = wanted - have;
    if (gaps <= 0) return [];

    var promoted = [];
    for (var n = 0; n < this.items.length && gaps > 0; n++) {
      var it = this.items[n];
      if (it.role !== 'extra' || it.hardware || it.sold_out || it.on) continue;
      it.on = true;
      it.role = 'chosen';

      /* Take the sold-out one off the screen and stand the replacement in its
       * place, rather than leaving a grey card sitting in her four and adding
       * the replacement quietly further down. She should only ever see four
       * blends she can actually buy. The card is MOVED, not copied, so the
       * "Add Another Blend" step below stops offering the same blend twice and
       * both step summaries stay right on their own. */
      var gone = blanks.shift();
      if (gone && gone.el && gone.el.parentNode) {
        gone.el.parentNode.insertBefore(it.el, gone.el);
        gone.el.hidden = true;
        gone.el.setAttribute('aria-hidden', 'true');
        gone.role = 'swapped';
      }

      promoted.push(it);
      gaps--;
    }
    return promoted;
  };

  Builder.prototype.byKey = function (k) {
    for (var i = 0; i < this.items.length; i++) if (this.items[i].key === k) return this.items[i];
    return null;
  };
  Builder.prototype.out = function (name) {
    return this.root.querySelector('[data-ttq-' + name + ']');
  };
  Builder.prototype.wire = function () {
    var self = this;
    this.items.forEach(function (i) { self.paintItem(i); });
  };

  Builder.prototype.paintItem = function (item) {
    item.el.classList.toggle('on', item.on);
    var btn = item.el.querySelector('[data-ttq-add]');
    if (btn) {
      var addLabel = btn.getAttribute('data-ttq-label-add') || 'Add';
      var removeLabel = btn.getAttribute('data-ttq-label-remove') || 'Remove';
      var soldLabel = btn.getAttribute('data-ttq-label-sold') || 'Sold out';
      btn.textContent = item.sold_out ? soldLabel : (item.on ? removeLabel : addLabel);
      btn.disabled = item.sold_out;
    }
  };

  Builder.prototype.chosen = function () {
    return this.items.filter(function (i) { return i.on; });
  };
  Builder.prototype.teaCount = function () {
    return this.chosen().filter(function (i) { return !i.hardware; }).length;
  };
  Builder.prototype.giftAvailable = function () {
    return this.freeOn && (this.freeOnSub || !this.sub);
  };
  Builder.prototype.giftEarned = function () {
    return this.giftAvailable() && this.teaCount() >= this.threshold;
  };

  Builder.prototype.paintSteps = function () {
    var self = this;
    qsa('[data-ttq-step]', this.root).forEach(function (el) {
      var n = parseInt(el.getAttribute('data-ttq-step'), 10);
      el.classList.toggle('open', n === self.openStep);
      el.classList.toggle('done', n < self.openStep);
      var circ = el.querySelector('[data-ttq-step-circle]');
      if (circ) circ.innerHTML = n < self.openStep ? '&#10003;' : String(n);
    });
    this.paintStepSummaries();
  };

  Builder.prototype.paintStepSummaries = function () {
    var self = this;
    qsa('[data-ttq-step]', this.root).forEach(function (el) {
      var sum = el.querySelector('[data-ttq-step-sum]');
      if (!sum) return;
      var kind = el.getAttribute('data-ttq-kind');
      if (kind === 'gift') {
        sum.textContent = self.giftEarned()
          ? (sum.getAttribute('data-ttq-earned') || 'Included, no charge')
          : (self.giftAvailable()
              ? (sum.getAttribute('data-ttq-locked') || 'Add 3 blends to unlock')
              : (sum.getAttribute('data-ttq-subonly') || 'With a one-time order'));
        return;
      }
      var keys = qsa('[data-ttq-item]', el).map(function (r) {
        return r.getAttribute('data-ttq-item');
      });
      var on = self.chosen().filter(function (i) { return keys.indexOf(i.key) > -1; });
      if (!on.length) { sum.textContent = sum.getAttribute('data-ttq-empty') || 'Nothing added'; return; }
      var spend = on.reduce(function (a, i) { return a + i.price; }, 0);
      sum.textContent = on.length + ' added · ' + money(spend);
    });
  };

  /* ------------------------------------------------------ what the store does
   * The offer changed on 15/08/2026. TEASEQUIZ15 is gone. What is left is two
   * discounts that DO stack, plus the subscription plans.
   *
   * Everything below was read off real baskets that afternoon, by filling
   * /cart/add.js and reading /cart.js back, then walking one of them to a real
   * checkout. Both markets. Nothing here is worked out on paper.
   *
   *   ONE-TIME, Canada
   *   3 blends                  $66 list -> pays  $66.00   nothing off
   *   4 blends                  $88 list -> pays  $66.00   cheapest blend free
   *   5 blends                 $110 list -> pays  $88.00   still only ONE free
   *   4 blends + mug, code     $203 list -> pays $158.00   free blend AND 20% off the mug
   *   4 blends + mug, no code  $203 list -> pays $181.00   mug at full price
   *   3 blends + mug, code     $181 list -> pays $158.00   no free blend at three
   *   mug on its own, code     $115 list -> pays  $92.00
   *
   *   ONE-TIME, USA, the real Energy & Focus ritual (matcha is $35)
   *   4 blends                 $101 list -> pays  $79.00   the $22 blend went free, not the $35
   *   4 blends + mug, code     $216 list -> pays $171.00
   *
   *   AUTO-SHIP, Canada                     AUTO-SHIP, USA
   *   3 blends        -> $42.90             4 blends w/ matcha -> $76.15
   *   4 blends        -> $57.20             4 blends + mug, code -> $168.15
   *   4 blends + mug, code -> $149.20
   *
   * Four things this proves, and every one of them changed the sum:
   *
   *   1. THE TWO DISCOUNTS STACK NOW. "Buy 3, Get Your 4th Free" and
   *      TEARITUAL20 are both PRODUCT discounts and both allow product
   *      discounts to combine, so the free blend and the 20% land together.
   *      The old sum showed the BIGGER of two, because on 15/08 they did not
   *      combine. Adding them is right today and was wrong yesterday.
   *   2. ONE free blend per ORDER, and it is the CHEAPEST blend. Five blends
   *      still take off only one, and in the US Energy kit the $22 blend went
   *      free while the $35 matcha did not.
   *   3. The free blend does NOT apply to auto-ship. Four blends on
   *      subscription take nothing off beyond the plan price.
   *   4. AUTO-SHIP IS NOT A FLAT PERCENTAGE. A $22 blend goes to $14.30, which
   *      is 35%. Organic Ceremonial Matcha goes from $35 to $33.25, which is
   *      5%. The old sum took 35% off everything and under-quoted the two kits
   *      that carry matcha by $10.50, which is the dangerous direction. Each
   *      blend now carries its own subscription price from its own plan.
   *
   * List price means what the store rings it up at, before anything comes off.
   * For a blend that is the price shown. For the mug, tumbler and whisk the
   * price shown is already the 20%-off number, so the list price is the
   * crossed-out one.
   */
  function listPriceOf(i) { return i.was > 0 ? i.was : i.price; }

  /* What the hardware really costs. `price` is already the 20%-off number, and
     the code that claims it is sent whenever there is hardware in the ritual,
     so the two cannot fall out of step. */
  function hardwarePriceOf(i) { return i.price; }

  /* What auto-ship really charges for one blend, off its own selling plan.
     A blend with no plan falls back to its full price rather than pretending
     to a saving that does not exist. */
  function subPriceOf(i) {
    if (i.hardware) return hardwarePriceOf(i);
    return i.subPrice > 0 ? i.subPrice : listPriceOf(i);
  }

  Builder.prototype.prices = function () {
    var items = this.chosen();
    var teas = items.filter(function (i) { return !i.hardware; });
    var hard = items.filter(function (i) { return i.hardware; });

    var teaList = teas.reduce(function (a, i) { return a + listPriceOf(i); }, 0);
    var hardList = hard.reduce(function (a, i) { return a + listPriceOf(i); }, 0);
    var hardPays = hard.reduce(function (a, i) { return a + hardwarePriceOf(i); }, 0);

    /* The cheapest blend, free, once there are MORE blends than the threshold.
       Threshold 3 means it lands at four. Once per order, never twice. */
    var freeBlend = (teas.length > this.threshold)
      ? Math.min.apply(null, teas.map(listPriceOf))
      : 0;

    var one = teaList - freeBlend + hardPays;
    var sub = teas.reduce(function (a, i) { return a + subPriceOf(i); }, 0) + hardPays;

    /* Both options cross out against the same thing: what the store would ring
       up with nothing taken off at all. */
    var full = teaList + hardList;
    var earned = this.giftEarned();
    return {
      items: items,
      earned: earned,
      /* Whether the free blend has landed on THIS basket. Separate from
         `earned`, which is the optional free-gift step and is switched off on
         all four live pages. */
      freeBlendOn: freeBlend > 0,
      freeBlend: freeBlend,
      /* How many more blends she needs before the fourth is free. */
      blendsShort: Math.max(0, (this.threshold + 1) - teas.length),
      hasHardware: hard.length > 0,
      one: one,
      oneSaving: full - one,
      sub: sub,
      subSaving: full - sub,
      oneFull: full,
      subFull: full,
      full: full
    };
  };

  Builder.prototype.recalc = function () {
    var p = this.prices();
    var total = this.sub ? p.sub : p.one;
    var self = this;

    var list = this.out('list');
    if (list) {
      var rows = p.items.map(function (i) {
        return '<li><span>' + esc(i.title) + '<small>' + esc(i.fn) + '</small></span>' +
               '<b>' + money(i.price) + '</b></li>';
      });
      if (this.freeOn) {
        var lockedNote = list.getAttribute('data-ttq-free-locked') || 'Add 3 blends to unlock this';
        var notYet = list.getAttribute('data-ttq-free-notyet') || 'Not yet';
        var freeWord = list.getAttribute('data-ttq-free-word') || 'Free';
        var subOnly = list.getAttribute('data-ttq-free-subonly') || 'With a one-time order';
        var offSub = !this.giftAvailable();
        rows.push('<li class="' + (p.earned ? '' : 'locked') + '"><span>' + esc(this.free.title) +
          '<small>' + esc(p.earned ? this.free.fn : (offSub ? subOnly : lockedNote)) + '</small></span>' +
          '<b class="' + (p.earned ? 'ttq-f' : '') + '">' + esc(p.earned ? freeWord : notYet) + '</b></li>');
      }
      list.innerHTML = rows.join('');
    }

    /* The nudge. Allan's call on 15/08/2026: she is allowed to drop to three
       blends, the page prices that honestly at full price, and it tells her the
       fourth costs nothing. Auto-ship gets no nudge, because the free blend
       genuinely does not apply to a subscription order.
     *
     * Both sentences are counted in BLENDS, not in everything in the basket,
     * and the numbers fed in are chosen so the wording already saved on the
     * four pages stays literally true:
     *
     *   earned: "COUNT in your ritual, plus your free blend."
     *           COUNT is the blends she PAYS for. Under buy-three-get-one she
     *           pays for three and a fourth arrives free, so "3, plus your free
     *           blend" is the offer said out loud. Feeding it the full four
     *           would promise a fifth blend that does not exist.
     *   locked: "COUNT in your ritual. Add SHORT more blendS and the fourth is
     *           free." COUNT is the blends she has.
     *
     * Counting the mug here is what made it read "4 in your ritual. Add 1 more
     * blend and the fourth is free," which contradicts itself. */
    var hint = this.out('hint');
    if (hint) {
      var blends = this.teaCount();
      if (this.sub) {
        hint.textContent = blends + (blends === 1 ? ' blend' : ' blends') + ' in your ritual.';
      } else if (p.freeBlendOn) {
        hint.textContent = (hint.getAttribute('data-ttq-earned') || 'COUNT in your ritual, plus your free blend.')
          .replace('COUNT', Math.max(0, blends - 1));
      } else {
        hint.textContent = (hint.getAttribute('data-ttq-locked') ||
          'COUNT in your ritual. Add SHORT more blendS and the fourth is free.')
          .replace('COUNT', blends).replace('SHORT', p.blendsShort)
          .replace('blendS', p.blendsShort === 1 ? 'blend' : 'blends');
      }
    }

    var giftRow = this.out('gift-row');
    if (giftRow) giftRow.classList.toggle('locked', !p.earned);
    var giftLock = this.out('gift-lock');
    if (giftLock) {
      giftLock.textContent = p.earned
        ? (giftLock.getAttribute('data-ttq-earned') || 'Included')
        : (this.giftAvailable()
            ? (giftLock.getAttribute('data-ttq-locked') || 'Add 3 blends')
            : (giftLock.getAttribute('data-ttq-subonly') || 'One-time only'));
    }
    var giftReq = this.out('gift-req');
    if (giftReq) {
      giftReq.textContent = p.earned
        ? (giftReq.getAttribute('data-ttq-earned') || 'Included, no charge')
        : (this.giftAvailable()
            ? (giftReq.getAttribute('data-ttq-locked') || 'Locked until 3 blends')
            : (giftReq.getAttribute('data-ttq-subonly') || 'With a one-time order'));
    }

    /* Anything one-time sitting in a subscription order gets called out, so
       nobody is surprised by what does and does not come back next month. */
    var note = this.out('onetime-note');
    if (note) {
      var oneOnly = p.items.filter(function (i) { return i.hardware; });
      if (this.sub && oneOnly.length) {
        var names = oneOnly.map(function (i) { return i.title; }).join(' and ');
        note.textContent = names + (oneOnly.length > 1 ? ' are' : ' is') +
          ' a one-time buy, not part of the subscription.';
      } else {
        note.textContent = '';
      }
    }

    var perCup = this.out('per-cup');
    if (perCup) perCup.textContent = money(total / this.cups) + (perCup.getAttribute('data-ttq-suffix') || ' a cup');

    /* The one-time label. It used to be baked into the Liquid as "One-time,
       save 15%", which was wrong at every basket size: at four blends the real
       saving is 25%, and at three there is none. It is written here instead,
       once the basket is actually known. */
    var oneLabel = this.out('one-label');
    if (oneLabel) {
      oneLabel.textContent = p.freeBlendOn
        ? (oneLabel.getAttribute('data-ttq-free') || 'One-time, your 4th blend free')
        : (oneLabel.getAttribute('data-ttq-none') || 'One-time');
    }

    set(this.out('one-price'), money(p.one));
    set(this.out('sub-price'), money(p.sub));
    /* A crossed-out price that is the same as the price beside it is noise, so it
       is left blank rather than printed. */
    set(this.out('one-was'), p.oneFull > p.one + 0.005 ? money(p.oneFull) : '');
    set(this.out('sub-was'), p.subFull > p.sub + 0.005 ? money(p.subFull) : '');
    set(this.out('total'), money(total));

    var totalLabel = this.out('total-label');
    if (totalLabel) {
      totalLabel.textContent = this.sub
        ? (totalLabel.getAttribute('data-ttq-sub') || 'Every 4 weeks')
        : (totalLabel.getAttribute('data-ttq-one') || 'Total today');
    }

    qsa('[data-ttq-plan-option]', this.root).forEach(function (el) {
      el.classList.toggle('on', (el.getAttribute('data-ttq-plan-option') === 'sub') === self.sub);
    });

    this.paintStepSummaries();
    this.paintSticky(p, total);
  };

  Builder.prototype.paintSticky = function (p, total) {
    if (!this.root.classList.contains(ROOT_LIVE) &&
        !this.root.closest('.' + ROOT_LIVE)) return;
    var note = document.querySelector('[data-ttq-sticky-note]');
    if (!note) return;
    var n = p.items.length + (p.earned ? 1 : 0);
    var saved = p.full - total;
    var word = n === 1 ? 'item' : 'items';
    note.innerHTML = '<b>' + n + ' ' + word + '</b> &middot; ' + money(total) +
      (saved > 0.005 ? ' &middot; <em>save ' + money(saved) + '</em>' : '');
  };

  Builder.prototype.scrollToOpen = function (toPanel) {
    var target = toPanel
      ? this.root.querySelector('[data-ttq-panel]')
      : this.root.querySelector('[data-ttq-step].open');
    if (target && target.scrollIntoView) {
      target.scrollIntoView({ block: 'center', behavior: 'smooth' });
    }
  };

  /* ------------------------------------------------- a basket call nobody sees
   * The Rebuy Smart Cart app replaces the browser's own fetch and XHR so it can
   * watch every basket call, and it slides its cart drawer open whenever it
   * sees one. Confirmed on the live page 15/08/2026: window.fetch is no longer
   * the browser's.
   *
   * This page does not want that. It fills the basket and goes straight to
   * checkout, so the drawer only flashes over the top on the way out, which
   * reads as "it took me to the cart instead of the checkout".
   *
   * The fix is to borrow a clean fetch from a blank same-origin iframe. Rebuy
   * never patched that one, so it never hears the call and the drawer stays
   * shut. The iframe carries the same cookies, so the basket is the same
   * basket. Nothing about Rebuy is disabled: the drawer still works everywhere
   * else on the store, and on this page from the header basket icon.
   *
   * If anything at all goes wrong, it falls back to the normal fetch, which is
   * exactly today's behaviour.
   */
  /* ------------------------------------------------------- the right country
   * The store runs more than one market. A Canadian shopper is on
   * teasetea.com/pages/..., an American is on teasetea.com/en-us/pages/...,
   * and Shopify hands the page its own prefix in Shopify.routes.root.
   *
   * Every basket and checkout address MUST carry that prefix. A plain
   * "/cart/add.js" is the CANADIAN basket whichever page it is called from, so
   * an American shopper was quietly moved into the Canadian market on her way
   * to pay. Caught on 15/08/2026 on the US Skin & Hair page: the page quoted
   * $171.00 USD, the checkout opened in CAD, Organic Ceremonial Matcha is sold
   * out in Canada so it was dropped from her basket, and she landed on a
   * "stock problems" page owing $158.00 for a kit that was one blend short.
   *
   * This was not introduced by the new pricing. The old checkout used the same
   * root-only addresses, so every American who reached this checkout met it.
   */
  function shopRoot() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return String(r).replace(/\/$/, '');
  }

  function quietFetch() {
    try {
      var f = document.getElementById('ttq-quiet-fetch');
      if (!f) {
        f = document.createElement('iframe');
        f.id = 'ttq-quiet-fetch';
        f.setAttribute('aria-hidden', 'true');
        f.setAttribute('tabindex', '-1');
        f.style.cssText = 'position:absolute;left:-9999px;width:0;height:0;border:0';
        document.body.appendChild(f);
      }
      var w = f.contentWindow;
      if (w && typeof w.fetch === 'function') return w.fetch.bind(w);
    } catch (e) { /* fall through */ }
    return window.fetch.bind(window);
  }

  /* --------------------------------------------------------------- checkout
   * A real Shopify basket, not a link that only looks like one. The blends go in
   * with their subscription plan when auto-ship is chosen, and the hardware
   * never does.
   *
   * Only ONE code can travel in a checkout address, and it is spent on the
   * hardware. Everything else is automatic and needs no code: "Buy 3, Get Your
   * 4th Free" applies on its own, and the auto-ship saving is carried by the
   * selling plan on each line.
   *
   * The code is sent ONLY when there is hardware in the ritual. It is a product
   * discount on the mug, tumbler and whisk, so with blends alone it can do
   * nothing, and sending it anyway puts a rejected-code message in front of her
   * at checkout for no gain. Measured 15/08/2026: four blends with the code and
   * four blends without it both come to $66.00.
   */
  Builder.prototype.checkout = function () {
    if (this.busy) return;
    var self = this;
    var p = this.prices();
    var buy = this.out('buy');

    var lines = p.items.map(function (i) {
      var line = { id: Number(i.vid), quantity: 1 };
      if (self.sub && !i.hardware && i.plan) line.selling_plan = Number(i.plan);
      return line;
    }).filter(function (l) { return l.id; });

    if (p.earned && this.free.vid) {
      var freeLine = { id: Number(this.free.vid), quantity: 1 };
      if (this.sub && this.free.plan) freeLine.selling_plan = Number(this.free.plan);
      lines.push(freeLine);
    }
    if (!lines.length) return;

    this.busy = true;
    if (buy) { buy.setAttribute('aria-busy', 'true'); }

    /* Her market's prefix. Everything below is built on it, so the basket she
       pays for is the basket in the country she is shopping from. */
    var root = shopRoot();
    var code = p.hasHardware ? (this.root.getAttribute('data-ttq-hw-code') || '') : '';
    var go = function () {
      window.location.href = code
        ? root + '/discount/' + encodeURIComponent(code) + '?redirect=' + encodeURIComponent(root + '/checkout')
        : root + '/checkout';
    };
    var send = quietFetch();
    var post = function (url, body) {
      return send(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify(body || {})
      });
    };

    var start = this.emptyFirst ? post(root + '/cart/clear.js') : Promise.resolve();
    start
      .then(function () { return post(root + '/cart/add.js', { items: lines }); })
      .then(function (r) {
        if (!r || !r.ok) throw new Error('cart refused the ritual');
        go();
      })
      .catch(function () {
        /* If the basket cannot be built (a blend sold out between the page
           loading and the tap), fall back to the plain permalink rather than
           leaving her on a dead button. */
        self.busy = false;
        if (buy) buy.removeAttribute('aria-busy');
        var permalink = lines.map(function (l) { return l.id + ':1'; }).join(',');
        window.location.href = root + '/cart/' + permalink + (code ? '?discount=' + encodeURIComponent(code) : '');
      });
  };

  function set(el, text) { if (el) el.textContent = text; }
  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c];
    });
  }

  /* ---------------------------------------------------------- the galleries
   * She swipes the strip sideways or taps a thumbnail. No arrows sitting on top
   * of the product. The thumbnail outline follows whichever shot has settled.
   */
  function wireGallery(pic) {
    if (pic.getAttribute('data-ttq-wired') === 'true') return;
    pic.setAttribute('data-ttq-wired', 'true');
    var frame = pic.querySelector('.ttq-frame');
    var imgs = qsa('.ttq-frame img', pic);
    var thumbs = qsa('.ttq-thumb', pic);
    if (!frame || imgs.length < 2) return;
    var at = -1;
    var strip = thumbs.length ? thumbs[0].parentNode : null;

    /* WHY THIS DOES NOT USE scrollIntoView, fixed 16/08/2026.
     * It used to, and that is what made the page open part way down instead of
     * at the top. Every gallery on the page wires itself as soon as it is
     * built, each one marks its first thumbnail, and scrollIntoView on a
     * thumbnail that is far below the fold drags the WHOLE PAGE down to it.
     * The last gallery to run won, so she landed on the fourth blend.
     * The only thing this ever needed to move is the thumbnail strip itself,
     * sideways, so that is all it does now. It also skips the very first mark,
     * because on load there is nothing to bring back into view. */
    function mark(n) {
      if (n === at) return;
      var first = at === -1;
      at = n;
      thumbs.forEach(function (b, k) { b.classList.toggle('on', k === n); });
      var a = thumbs[n];
      if (first || !a || !strip) return;
      var left = a.offsetLeft - (strip.clientWidth - a.offsetWidth) / 2;
      if (strip.scrollTo) strip.scrollTo({ left: left, behavior: 'smooth' });
      else strip.scrollLeft = left;
    }
    function fromScroll() {
      var w = frame.clientWidth || 1;
      mark(Math.max(0, Math.min(imgs.length - 1, Math.round(frame.scrollLeft / w))));
    }
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) {
          if (e.isIntersecting) mark(parseInt(e.target.getAttribute('data-gi'), 10));
        });
      }, { root: frame, threshold: 0.6 });
      imgs.forEach(function (im) { io.observe(im); });
    }
    var tm = null;
    frame.addEventListener('scroll', function () {
      if (tm) return;
      tm = setTimeout(function () { tm = null; fromScroll(); }, 110);
    }, { passive: true });
    thumbs.forEach(function (b) {
      b.addEventListener('click', function () {
        var n = parseInt(b.getAttribute('data-gt'), 10);
        /* Chrome drags a scripted scroll straight back to the current snap
           point, so snapping comes off for the jump and goes back after. */
        frame.style.scrollSnapType = 'none';
        frame.scrollLeft = n * frame.clientWidth;
        frame.style.scrollSnapType = '';
        mark(n);
      });
    });
    mark(0);
  }

  /* ------------------------------------------------- the ingredients pop-up
   * Keeps her on the page instead of sending her to the product page and losing
   * the sale.
   */
  function wireModal() {
    var modal = document.querySelector('[data-ttq-modal]');
    if (!modal || modal.getAttribute('data-ttq-wired') === 'true') return;
    modal.setAttribute('data-ttq-wired', 'true');
    var lastFocus = null;
    function open(btn) {
      lastFocus = btn;
      set(modal.querySelector('[data-ttq-modal-title]'), btn.getAttribute('data-ttq-ing-title'));
      set(modal.querySelector('[data-ttq-modal-fn]'), btn.getAttribute('data-ttq-ing-fn'));
      set(modal.querySelector('[data-ttq-modal-list]'), btn.getAttribute('data-ttq-ing-list'));
      set(modal.querySelector('[data-ttq-modal-note]'), btn.getAttribute('data-ttq-ing-note'));
      modal.classList.add('on');
      document.body.style.overflow = 'hidden';
      var close = modal.querySelector('[data-ttq-modal-close]');
      if (close) close.focus();
    }
    function close() {
      modal.classList.remove('on');
      document.body.style.overflow = '';
      if (lastFocus) lastFocus.focus();
    }
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-ttq-ing-title]');
      if (btn) { e.preventDefault(); open(btn); return; }
      if (e.target.closest('[data-ttq-modal-close]') || e.target.closest('[data-ttq-modal-scrim]')) {
        close();
      }
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && modal.classList.contains('on')) close();
    });
  }

  /* ------------------------------------------------ the video wall arrows */
  function wireWall() {
    qsa('[data-ttq-wall]').forEach(function (wrap) {
      if (wrap.getAttribute('data-ttq-wired') === 'true') return;
      wrap.setAttribute('data-ttq-wired', 'true');
      var strip = wrap.querySelector('.ttq-wall');
      if (!strip) return;
      qsa('[data-ttq-wall-nav]', wrap).forEach(function (b) {
        b.addEventListener('click', function () {
          var dir = b.getAttribute('data-ttq-wall-nav') === 'next' ? 1 : -1;
          var card = strip.querySelector('.ttq-wcard');
          if (card) strip.scrollBy({ left: dir * (card.offsetWidth + 12), behavior: 'smooth' });
        });
      });
      strip.addEventListener('click', function (e) {
        var card = e.target.closest('.ttq-wcard');
        if (!card) return;
        var vid = card.querySelector('video');
        if (!vid) return;
        var play = card.querySelector('.ttq-play');
        if (play) play.style.display = 'none';
        vid.controls = true;
        vid.play();
      });
    });
  }

  /* ---------------------------------------------------------- sticky bar
   * Stays hidden until she has read past the builder. After that it is armed for
   * good, so scrolling back up still shows it. Nothing competes with the ritual
   * on the way down.
   */
  function wireSticky() {
    var sticky = document.querySelector('[data-ttq-sticky]');
    if (!sticky || sticky.getAttribute('data-ttq-wired') === 'true') return;
    sticky.setAttribute('data-ttq-wired', 'true');

    var armed = false;
    function arm() {
      if (armed) return;
      armed = true;
      sticky.classList.add('on');
    }

    /* An observer rather than a scroll listener, for two reasons.
       The first is that it is the right tool: it fires exactly when the builder
       comes into view and costs nothing in between.
       The second is that it is the only one that works here. This theme's pages
       do not send scroll events to the window at all (the body is set to
       overflow:hidden and the scrolling happens elsewhere), so the scroll
       listener this used to rely on never ran once and the bar never appeared.
       Every anchor on the page is watched: the three kits she did not match are
       display:none, and a hidden element never intersects, so only the kit she is
       actually looking at can arm the bar. */
    if (window.IntersectionObserver) {
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) { if (e.isIntersecting) arm(); });
      }, { threshold: 0.08 });
      qsa('[data-ttq-arm-sticky]').forEach(function (a) { io.observe(a); });
    } else {
      /* No observer: show it rather than never showing it. */
      arm();
    }

    /* Belt and braces, in case a future theme change starts sending scroll
       events again and the observer is ever blocked. */
    var onScroll = function () {
      var live = document.querySelector('[data-ttq-arm-sticky].' + ROOT_LIVE);
      if (live && live.getBoundingClientRect().top < window.innerHeight * 0.75) arm();
    };
    window.addEventListener('scroll', onScroll, { passive: true });
    document.addEventListener('scroll', onScroll, { passive: true, capture: true });
  }

  /* ------------------------------------------------------ the review switcher
   * Review tool only. Appears with ?preview=1 so Sheena can walk all four kits
   * from one address. A shopper never sees it.
   */
  function wirePreview(current, name) {
    var bar = document.querySelector('[data-ttq-preview]');
    if (!bar) return;
    document.documentElement.classList.add('ttq-previewing');
    qsa('[data-ttq-preview-kit]', bar).forEach(function (b) {
      b.setAttribute('aria-pressed', String(b.getAttribute('data-ttq-preview-kit') === current));
      b.addEventListener('click', function () {
        var kit = b.getAttribute('data-ttq-preview-kit');
        qsa('[data-ttq-preview-kit]', bar).forEach(function (x) {
          x.setAttribute('aria-pressed', String(x === b));
        });
        showKit(kit);
        boot(kit);
        window.scrollTo({ top: 0 });
      });
    });
    var input = bar.querySelector('[data-ttq-preview-name]');
    if (input) {
      if (name) input.value = name;
      input.addEventListener('input', function () { fillName(input.value.trim()); });
      fillName(input.value.trim());
    }
  }

  /* ------------------------------------------------- release the Alia lock
   * The store's Alia e-mail pop-up is hidden on these four pages by a rule in
   * ttq-base.css. Hiding it alone is not enough: Alia locks the page by writing
   * style="overflow: hidden" straight onto <body>, and it only clears that when
   * somebody closes it. With its close button hidden, nothing ever does, so the
   * page cannot be scrolled at all. Checked on the live page 15/08/2026.
   *
   * This clears that one lock, and keeps clearing it if Alia writes it again.
   *
   * It is deliberately narrow:
   *   - it touches ONLY the inline `overflow` on <body>. The theme's own drawers
   *     and the Rebuy cart lock the page with a CLASS (`js-drawer-open`,
   *     `lock-scroll`, `modal-open`, `rebuy-cart-visible`), so they still work
   *     exactly as before;
   *   - it stands down while THIS page's own ingredients pop-up is open, because
   *     that one uses the same inline lock on purpose (see wireModal above).
   *
   * Alia loads AFTER this script, so we cannot check for it once and give up.
   * The watcher is installed either way and does nothing until Alia is actually
   * on the page.
   *
   * If Alia is ever excluded from these pages in the Alia app itself, which is
   * the tidier fix, this can be deleted along with the CSS rule.
   */
  var aliaWatchOn = false;

  function releaseAliaScrollLock() {
    if (aliaWatchOn) return;              // start() runs again on section load
    aliaWatchOn = true;
    function unlock() {
      if (!document.querySelector('div[id^="alia-root"]')) return; // not Alia's lock
      if (document.querySelector('[data-ttq-modal].on')) return;   // our own pop-up
      if (document.body.style.overflow === 'hidden') document.body.style.overflow = '';
    }
    unlock();
    try {
      new MutationObserver(unlock).observe(document.body, {
        attributes: true, attributeFilter: ['style'], childList: true
      });
    } catch (e) { /* very old browser: the one-off unlock above still ran */ }
  }

  /* ------------------------------------------------------------------ start */
  var builders = [];

  function boot(kit) {
    builders = qsa('[data-ttq-builder]')
      .filter(function (b) { return b.closest('[data-ttq-result="' + kit + '"]'); })
      .map(function (b) { return new Builder(b); });
    qsa('[data-ttq-result="' + kit + '"] [data-ttq-gallery]').forEach(wireGallery);
  }

  function start() {
    var p = params();
    var kit = chooseKit();
    var name = (p.get('name') || p.get('first_name') || '').trim().slice(0, 40);
    showKit(kit);
    fillName(name);
    boot(kit);
    wireModal();
    wireWall();
    wireSticky();
    releaseAliaScrollLock();
    if (p.get('preview') === '1' || p.get('preview') === 'true') wirePreview(kit, name);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  /* The theme editor swaps one section at a time without reloading, which would
     otherwise leave that section unwired and its prices blank. */
  document.addEventListener('shopify:section:load', function () { start(); });
})();
